(() => {
  const NAMEPLATE_PRODUCT_ID = '8784217309436';
  const FIELD_ENDPOINT = '/apps/codemate-product-custom-fields/extension/get-fields';
  const FIELD_WRAPPER_SELECTOR = '[data-cartly-nameplate-fields]';
  const FIELD_INPUT_SELECTOR = '[data-cartly-nameplate-input]';
  const GENERAL_ERROR_SELECTOR = '[data-cartly-nameplate-general-error]';
  const FALLBACK_FIELDS = [
    {
      id: 'line-1',
      label: 'Line 1 ( Up to 30 characters per line)',
      orderLabel: 'Line 1 ( Up to 30 characters per line)',
      isRequired: true,
      maxLength: 30
    },
    {
      id: 'line-2',
      label: 'Line 2 ( Up to 30 characters per line)',
      orderLabel: 'Line 2 ( Up to 30 characters per line)',
      isRequired: false,
      maxLength: 30
    },
    {
      id: 'line-3',
      label: 'Line 3 ( Up to 30 characters per line)',
      orderLabel: 'Line 3 ( Up to 30 characters per line)',
      isRequired: false,
      maxLength: 30
    }
  ];

  let fieldsPromise;
  let observerStarted = false;
  let refreshScheduled = false;

  function injectStyles() {
    if (document.getElementById('cartly-nameplate-fields-style')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'cartly-nameplate-fields-style';
    style.textContent = `
      .cartly-nameplate-fields {
        margin: 12px 0;
      }

      .spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"] {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
      }

      .spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"] > * {
        width: 100%;
      }

      .spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"] .spurit-occ3__select-container,
      .spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"] [data-upsell-atc] {
        width: 100%;
      }

      .spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"] .spurit-occ3__select-container {
        margin: 0;
      }

      .spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"] .spurit-occ3__select-container select {
        width: 100%;
      }

      .spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"] [data-upsell-atc] {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 42px;
        padding: 10px 16px;
        line-height: 1.2;
      }

      .spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"] [data-upsell-atc] span {
        display: block;
        line-height: 1.2;
      }

      .cartly-nameplate-fields__field + .cartly-nameplate-fields__field {
        margin-top: 10px;
      }

      .cartly-nameplate-fields__label {
        display: block;
        margin-bottom: 4px;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.35;
        color: #222;
      }

      .cartly-nameplate-fields__required {
        color: #c62828;
      }

      .cartly-nameplate-fields__input {
        width: 100%;
        min-width: 0;
        padding: 9px 10px;
        border: 1px solid #cfcfcf;
        border-radius: 4px;
        background: #fff;
        color: #222;
        font-size: 13px;
        line-height: 1.4;
      }

      .cartly-nameplate-fields__input:focus {
        outline: 0;
        border-color: #0088cc;
        box-shadow: 0 0 0 2px rgba(0, 136, 204, 0.12);
      }

      .cartly-nameplate-fields__input[aria-invalid="true"] {
        border-color: #c62828;
      }

      .cartly-nameplate-fields__meta {
        display: flex;
        justify-content: space-between;
        gap: 8px;
        margin-top: 4px;
      }

      .cartly-nameplate-fields__error,
      .cartly-nameplate-fields__general-error,
      .cartly-nameplate-fields__count {
        font-size: 11px;
        line-height: 1.35;
      }

      .cartly-nameplate-fields__error,
      .cartly-nameplate-fields__general-error {
        color: #c62828;
      }

      .cartly-nameplate-fields__count {
        margin-left: auto;
        color: #666;
      }

      .cartly-nameplate-fields__button-loading {
        opacity: 0.7;
      }
    `;

    document.head.appendChild(style);
  }

  function fetchFields() {
    if (!fieldsPromise) {
      fieldsPromise = fetch(FIELD_ENDPOINT, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/javascript',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          productId: Number(NAMEPLATE_PRODUCT_ID),
          collections: [],
          isHomePage: false,
          locale: (window.Shopify && window.Shopify.locale) || 'en'
        })
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Unable to load custom fields');
          }

          return response.json();
        })
        .then((payload) => {
          if (!payload || !Array.isArray(payload.fields) || payload.fields.length === 0) {
            return FALLBACK_FIELDS;
          }

          return payload.fields
            .filter((field) => field && field.type === 'text')
            .map((field, index) => ({
              id: field.id || `field-${index}`,
              label: field.label && field.label.text ? field.label.text : field.orderLabel || `Line ${index + 1}`,
              orderLabel: field.orderLabel || (field.label && field.label.text) || `Line ${index + 1}`,
              isRequired: Boolean(field.isRequired),
              maxLength: Number(field.maxLength) || 30
            }));
        })
        .catch(() => FALLBACK_FIELDS);
    }

    return fieldsPromise;
  }

  function getTargetForms(root = document) {
    return Array.from(
      root.querySelectorAll(
        `.spurit-occ3__upsell .spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"]`
      )
    );
  }

  function createFieldNode(field) {
    const fieldNode = document.createElement('div');
    fieldNode.className = 'cartly-nameplate-fields__field';
    fieldNode.dataset.cartlyFieldId = field.id;
    fieldNode.dataset.cartlyOrderLabel = field.orderLabel;
    fieldNode.dataset.cartlyRequired = field.isRequired ? 'true' : 'false';
    fieldNode.dataset.cartlyMaxLength = String(field.maxLength);

    const label = document.createElement('label');
    label.className = 'cartly-nameplate-fields__label';
    label.htmlFor = `cartly-nameplate-${field.id}`;
    label.textContent = field.label;

    if (field.isRequired) {
      const required = document.createElement('span');
      required.className = 'cartly-nameplate-fields__required';
      required.textContent = ' *';
      label.appendChild(required);
    }

    const input = document.createElement('input');
    input.className = 'cartly-nameplate-fields__input';
    input.id = `cartly-nameplate-${field.id}`;
    input.type = 'text';
    input.maxLength = field.maxLength;
    input.autocomplete = 'off';
    input.dataset.cartlyNameplateInput = 'true';
    input.dataset.cartlyFieldId = field.id;
    input.dataset.cartlyOrderLabel = field.orderLabel;

    const meta = document.createElement('div');
    meta.className = 'cartly-nameplate-fields__meta';

    const error = document.createElement('div');
    error.className = 'cartly-nameplate-fields__error';
    error.dataset.cartlyFieldError = field.id;

    const count = document.createElement('div');
    count.className = 'cartly-nameplate-fields__count';
    count.dataset.cartlyFieldCount = field.id;
    count.textContent = `0/${field.maxLength}`;

    meta.appendChild(error);
    meta.appendChild(count);

    fieldNode.appendChild(label);
    fieldNode.appendChild(input);
    fieldNode.appendChild(meta);

    return fieldNode;
  }

  function enhanceForm(form, fields) {
    if (form.querySelector(FIELD_WRAPPER_SELECTOR)) {
      return;
    }

    const button = form.querySelector('[data-upsell-atc]');

    if (!button) {
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'cartly-nameplate-fields';
    wrapper.dataset.cartlyNameplateFields = 'true';

    fields.forEach((field) => {
      wrapper.appendChild(createFieldNode(field));
    });

    const generalError = document.createElement('div');
    generalError.className = 'cartly-nameplate-fields__general-error';
    generalError.dataset.cartlyNameplateGeneralError = 'true';
    wrapper.appendChild(generalError);

    button.parentNode.insertBefore(wrapper, button);
  }

  function refreshForms() {
    if (refreshScheduled) {
      return;
    }

    refreshScheduled = true;

    window.requestAnimationFrame(() => {
      refreshScheduled = false;

      fetchFields().then((fields) => {
        getTargetForms().forEach((form) => {
          enhanceForm(form, fields);
        });
      });
    });
  }

  function startObserver() {
    if (observerStarted || !document.body) {
      return;
    }

    observerStarted = true;

    const observer = new MutationObserver((mutations) => {
      const shouldRefresh = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== 1) {
            return false;
          }

          if (node.matches && node.matches(`.spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"]`)) {
            return true;
          }

          return Boolean(
            node.querySelector &&
              node.querySelector(`.spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"]`)
          );
        })
      );

      if (shouldRefresh) {
        refreshForms();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function updateCount(input) {
    const fieldNode = input.closest('[data-cartly-field-id]');
    const count = fieldNode && fieldNode.querySelector('[data-cartly-field-count]');

    if (!count) {
      return;
    }

    count.textContent = `${input.value.length}/${input.maxLength || 0}`;
  }

  function clearFieldError(input) {
    input.setAttribute('aria-invalid', 'false');

    const fieldNode = input.closest('[data-cartly-field-id]');
    const error = fieldNode && fieldNode.querySelector('[data-cartly-field-error]');

    if (error) {
      error.textContent = '';
    }
  }

  function setFieldError(input, message) {
    input.setAttribute('aria-invalid', 'true');

    const fieldNode = input.closest('[data-cartly-field-id]');
    const error = fieldNode && fieldNode.querySelector('[data-cartly-field-error]');

    if (error) {
      error.textContent = message;
    }
  }

  function setGeneralError(form, message) {
    const error = form.querySelector(GENERAL_ERROR_SELECTOR);

    if (error) {
      error.textContent = message || '';
    }
  }

  function getVariantId(form) {
    const select = form.querySelector('select');

    if (select && select.value) {
      return select.value;
    }

    const hiddenInputs = Array.from(form.querySelectorAll('input[type="hidden"][value]')).filter((input) =>
      /^\d+$/.test(input.value)
    );

    return hiddenInputs.length ? hiddenInputs[0].value : '';
  }

  function collectProperties(form, fields) {
    const properties = {};
    let firstInvalidInput = null;

    fields.forEach((field) => {
      const input = form.querySelector(`${FIELD_INPUT_SELECTOR}[data-cartly-field-id="${field.id}"]`);

      if (!input) {
        return;
      }

      const value = input.value.trim();
      clearFieldError(input);
      updateCount(input);

      if (field.isRequired && !value) {
        setFieldError(input, 'This field is required.');
        firstInvalidInput = firstInvalidInput || input;
        return;
      }

      if (value) {
        properties[field.orderLabel] = value;
      }
    });

    return {
      properties,
      firstInvalidInput
    };
  }

  function setButtonLoading(button, isLoading) {
    const textNode = button.querySelector('span');

    if (!button.dataset.originalButtonText && textNode) {
      button.dataset.originalButtonText = textNode.textContent;
    }

    button.disabled = isLoading;
    button.classList.toggle('cartly-nameplate-fields__button-loading', isLoading);

    if (textNode) {
      textNode.textContent = isLoading ? 'Adding...' : button.dataset.originalButtonText || 'Add to cart';
    }
  }

  function refreshCartDrawer() {
    document.documentElement.dispatchEvent(
      new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          quantity: 1
        }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );

    const cartDrawer =
      window.Spurit &&
      window.Spurit.OneClickCheckout3 &&
      window.Spurit.OneClickCheckout3.cartDrawer;

    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      cartDrawer.refresh();
    }
  }

  async function addNameplateToCart(button, form, fields) {
    const variantId = getVariantId(form);

    if (!variantId) {
      setGeneralError(form, 'Please choose a variant before adding this item.');
      return;
    }

    const { properties, firstInvalidInput } = collectProperties(form, fields);

    if (firstInvalidInput) {
      firstInvalidInput.focus();
      setGeneralError(form, 'Please complete the required field before adding this item.');
      return;
    }

    setGeneralError(form, '');
    setButtonLoading(button, true);

    try {
      const response = await fetch(`${window.routes.cartAddUrl}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          properties
        })
      });

      if (!response.ok) {
        throw new Error('Unable to add item');
      }

      refreshCartDrawer();
    } catch (error) {
      setGeneralError(form, 'There was a problem adding this item. Please try again.');
    } finally {
      setButtonLoading(button, false);
    }
  }

  function handleDocumentClick(event) {
    const button = event.target.closest('[data-upsell-atc]');

    if (!button) {
      return;
    }

    const form = button.closest(`.spurit-occ3__product-form[data-product-id="${NAMEPLATE_PRODUCT_ID}"]`);

    if (!form || !form.closest('.spurit-occ3__upsell')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    fetchFields().then((fields) => {
      addNameplateToCart(button, form, fields);
    });
  }

  function handleDocumentInput(event) {
    const input = event.target.closest(FIELD_INPUT_SELECTOR);

    if (!input) {
      return;
    }

    clearFieldError(input);
    updateCount(input);
  }

  injectStyles();
  refreshForms();
  startObserver();

  document.addEventListener('click', handleDocumentClick, true);
  document.addEventListener('input', handleDocumentInput);
})();

(() => {
  const CHECKBOX_SELECTOR = '[data-sizing-acknowledgment]';
  const ERROR_SELECTOR = '[data-sizing-acknowledgment-error]';
  const CARTLY_CART_SELECTOR = '.spurit-occ3__slide-drawer, .spurit-occ3-popup';
  const CARTLY_CHECKOUT_SELECTOR = '[data-occ3="checkout"]';
  const CARTLY_ACKNOWLEDGMENT_SELECTOR = '[data-cartly-sizing-acknowledgment]';
  const RETURN_POLICY_URL = '/pages/return-exchange-policy';
  const SIZING_CONFIRMATION_VALUE = 'Measurements reviewed; sizing returns not accepted';

  let cartlyRefreshScheduled = false;

  function getWrapper(checkbox) {
    return checkbox.closest('[data-sizing-acknowledgment-wrapper]');
  }

  function setError(checkbox, shouldShow) {
    const wrapper = getWrapper(checkbox);
    const error = wrapper && wrapper.querySelector(ERROR_SELECTOR);

    checkbox.setAttribute('aria-invalid', shouldShow ? 'true' : 'false');

    if (error) {
      error.hidden = !shouldShow;
    }

    if (wrapper) {
      wrapper.classList.toggle('sizing-acknowledgment--error', shouldShow);
    }
  }

  function validateForm(form, shouldFocus) {
    const checkbox = form.querySelector(CHECKBOX_SELECTOR);

    if (!checkbox || checkbox.checked) {
      if (checkbox) {
        setError(checkbox, false);
      }

      return true;
    }

    setError(checkbox, true);

    if (shouldFocus) {
      checkbox.focus({ preventScroll: true });
      checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    return false;
  }

  function createCartlyAcknowledgment(drawer) {
    const index = document.querySelectorAll(CARTLY_ACKNOWLEDGMENT_SELECTOR).length + 1;
    const id = `cartly-sizing-acknowledgment-${index}`;
    const wrapper = document.createElement('div');

    wrapper.className = 'sizing-acknowledgment sizing-acknowledgment--cartly';
    wrapper.dataset.sizingAcknowledgmentWrapper = 'true';
    wrapper.dataset.cartlySizingAcknowledgment = 'true';
    wrapper.innerHTML = `
      <label class="sizing-acknowledgment__label" for="${id}">
        <input
          id="${id}"
          class="sizing-acknowledgment__checkbox"
          type="checkbox"
          name="attributes[Sizing confirmation]"
          value="${SIZING_CONFIRMATION_VALUE}"
          data-sizing-acknowledgment
          aria-describedby="${id}-help ${id}-error"
          required
        >
        <span>
          I have reviewed the measurements and understand this handmade item cannot be returned due to sizing or fit errors.
        </span>
      </label>

      <p id="${id}-help" class="sizing-acknowledgment__help">
        Damaged or defective items will still be replaced. <a href="${RETURN_POLICY_URL}" class="link link--accented">View return policy</a>.
      </p>

      <p id="${id}-error" class="sizing-acknowledgment__error" data-sizing-acknowledgment-error hidden>
        Please confirm you reviewed the measurements before checkout.
      </p>
    `;

    const checkout = drawer.querySelector(CARTLY_CHECKOUT_SELECTOR);
    const actions = checkout && checkout.closest('.spurit-occ3__actions, .spurit-occ3-actions-row');

    if (actions && actions.parentNode) {
      actions.parentNode.insertBefore(wrapper, actions);
      return true;
    }

    if (checkout && checkout.parentNode) {
      checkout.parentNode.insertBefore(wrapper, checkout);
      return true;
    }

    return false;
  }

  function enhanceCartlyDrawer(drawer) {
    if (drawer.querySelector(CARTLY_ACKNOWLEDGMENT_SELECTOR) || !drawer.querySelector(CARTLY_CHECKOUT_SELECTOR)) {
      return;
    }

    createCartlyAcknowledgment(drawer);
  }

  function refreshCartlyDrawers(root = document) {
    root.querySelectorAll(CARTLY_CART_SELECTOR).forEach((drawer) => {
      enhanceCartlyDrawer(drawer);
    });
  }

  function scheduleCartlyRefresh(root = document) {
    if (cartlyRefreshScheduled) {
      return;
    }

    cartlyRefreshScheduled = true;

    window.requestAnimationFrame(() => {
      cartlyRefreshScheduled = false;
      refreshCartlyDrawers(root);
    });
  }

  function startCartlyObserver() {
    if (!document.body) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      const shouldRefresh = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType !== 1) {
            return false;
          }

          if (node.matches && node.matches(CARTLY_CART_SELECTOR)) {
            return true;
          }

          return Boolean(node.querySelector && node.querySelector(CARTLY_CART_SELECTOR));
        })
      );

      if (shouldRefresh) {
        scheduleCartlyRefresh();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  async function persistSizingConfirmation(options = {}) {
    await fetch(`${window.routes.cartUrl}/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: Boolean(options.keepalive),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        attributes: {
          'Sizing confirmation': SIZING_CONFIRMATION_VALUE
        }
      })
    });
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest(CHECKBOX_SELECTOR);

    if (checkbox) {
      setError(checkbox, false);

      if (checkbox.checked) {
        persistSizingConfirmation({ keepalive: true }).catch(() => {});
      }
    }
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || !form.querySelector(CHECKBOX_SELECTOR)) {
        return;
      }

      if (!validateForm(form, true)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');

      if (!checkoutButton) {
        return;
      }

      const form = checkoutButton.closest('form');

      if (form && form.querySelector(CHECKBOX_SELECTOR) && !validateForm(form, true)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const checkoutButton = event.target.closest(CARTLY_CHECKOUT_SELECTOR);

      if (!checkoutButton) {
        return;
      }

      const drawer = checkoutButton.closest(CARTLY_CART_SELECTOR);
      const checkbox = drawer && drawer.querySelector(CHECKBOX_SELECTOR);

      if (!drawer || !checkbox) {
        return;
      }

      if (!checkbox.checked) {
        event.preventDefault();
        event.stopPropagation();

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        setError(checkbox, true);
        checkbox.focus({ preventScroll: true });
        checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      setError(checkbox, false);
      persistSizingConfirmation({ keepalive: true }).catch(() => {});
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      refreshCartlyDrawers();
      startCartlyObserver();
    });
  } else {
    refreshCartlyDrawers();
    startCartlyObserver();
  }
})();

(() => {
  const MOBILE_MEDIA = '(max-width: 640px)';
  const SOCIAL_PROOF_PATTERN =
    /(fomo|social[-_ ]?proof|proof[-_ ]?factor|sales[-_ ]?pop|sale[-_ ]?pop|sales[-_ ]?notification|recent[-_ ]?(sale|order|purchase)|recently[-_ ]?(bought|purchased)|purchase[-_ ]?(notification|popup)|order[-_ ]?notification|proof[-_ ]?notification|sales[-_ ]?popup)/i;
  const SOCIAL_PROOF_TEXT_PATTERN =
    /(recently bought|recently purchased|just bought|just purchased|someone .* purchased|someone .* bought|verified buyer|bought this|purchased this)/i;
  const MOBILE_SOCIAL_PROOF_SELECTORS = [
    '[id*="fomo" i]',
    '[class*="fomo" i]',
    '[src*="fomo" i]',
    '[href*="fomo" i]',
    '[id*="social-proof" i]',
    '[class*="social-proof" i]',
    '[id*="sales-pop" i]',
    '[class*="sales-pop" i]',
    '[id*="sale-pop" i]',
    '[class*="sale-pop" i]',
    '[id*="proof-factor" i]',
    '[class*="proof-factor" i]'
  ].join(',');

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MEDIA).matches;
  }

  function elementTokenString(element) {
    return [
      element.id,
      typeof element.className === 'string' ? element.className : '',
      element.getAttribute('src'),
      element.getAttribute('href'),
      element.getAttribute('data-src'),
      element.getAttribute('aria-label'),
      element.getAttribute('data-testid'),
      element.getAttribute('data-test-id'),
      element.getAttribute('data-app'),
      element.getAttribute('data-app-name')
    ]
      .filter(Boolean)
      .join(' ');
  }

  function looksLikeMobileSocialProof(element) {
    if (!(element instanceof HTMLElement)) {
      return false;
    }

    if (element.matches(MOBILE_SOCIAL_PROOF_SELECTORS)) {
      return true;
    }

    if (SOCIAL_PROOF_PATTERN.test(elementTokenString(element))) {
      return true;
    }

    const style = window.getComputedStyle(element);
    const isFloating = style.position === 'fixed' || style.position === 'sticky';
    const text = element.innerText || element.textContent || '';

    return isFloating && SOCIAL_PROOF_TEXT_PATTERN.test(text);
  }

  function removeMobileSocialProof(root = document) {
    if (!isMobile()) {
      return;
    }

    if (root instanceof Element && root.matches(MOBILE_SOCIAL_PROOF_SELECTORS)) {
      root.remove();
      return;
    }

    Array.from(root.querySelectorAll('*')).forEach((element) => {
      if (looksLikeMobileSocialProof(element)) {
        element.remove();
      }
    });
  }

  function injectMobileSocialProofStyles() {
    if (document.getElementById('mobile-social-proof-cleanup-style')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'mobile-social-proof-cleanup-style';
    style.textContent = `
      @media screen and (max-width: 640px) {
        [id*="fomo" i],
        [class*="fomo" i],
        iframe[src*="fomo" i],
        [id*="social-proof" i],
        [class*="social-proof" i],
        [id*="sales-pop" i],
        [class*="sales-pop" i],
        [id*="sale-pop" i],
        [class*="sale-pop" i],
        [id*="proof-factor" i],
        [class*="proof-factor" i] {
          display: none !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function startMobileSocialProofCleanup() {
    injectMobileSocialProofStyles();
    removeMobileSocialProof();

    const observer = new MutationObserver((mutations) => {
      if (!isMobile()) {
        return;
      }

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) {
            return;
          }

          if (looksLikeMobileSocialProof(node)) {
            node.remove();
            return;
          }

          removeMobileSocialProof(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    let cleanupRuns = 0;
    const cleanupTimer = window.setInterval(() => {
      cleanupRuns += 1;
      removeMobileSocialProof();

      if (cleanupRuns >= 30) {
        window.clearInterval(cleanupTimer);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startMobileSocialProofCleanup);
  } else {
    startMobileSocialProofCleanup();
  }
})();
